<template>
<div class="chapter">
<div class="inner_page">
<p class="half">Other Books in the Series</p>
<div class="figure">
<img alt="" src="images/pg1.jpg"/>
</div>
<div class="figure">
<img alt="" src="images/pg1-1.jpg"/>
</div>
<div class="figure">
<img alt="" src="images/pg1-2.jpg"/>
</div>
<div class="figure">
<img alt="" src="images/pg1-3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_frontmatter01.vue?213269e5